import { InmateContactFilters } from '@reliance/types/filters/InmateContactFilters';
import { InmateContactResult } from '@reliance/types/models/InmateContact';
import { useAsync } from 'react-async-hook';
import api from '../common/api';
import { IPaginatedResponse } from '../common/reliance-api-service';

export const useInmateContactsByInmateId = (
  inmateId: number | null | undefined,
  filters?: InmateContactFilters
) => {
  return useAsync<IPaginatedResponse<InmateContactResult>>(
    (currentInmateId?: number | null | undefined) => {
      const id = currentInmateId !== undefined ? currentInmateId : inmateId;
      if (!id) {
        return null;
      }

      const params: InmateContactFilters = {
        inmateId: id,
        ...filters,
      };

      return api
        .get<IPaginatedResponse<InmateContactResult>>('/inmate-contact', { params })
        .then((r) => r.data);
    },
    // Use empty array when inmateId is null to prevent auto-execution (for manual control)
    inmateId === null ? [] : [inmateId, filters]
  );
};
